"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = exports.isSoftBadgeColor = exports.badgeStyles = exports.baseBadgeStyles = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var badgeUtils_1 = require("../badgeUtils");
var types_1 = require("./types");
var baseBadgeStyles = function (selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  padding: 6px 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 73px;\n  border-radius: 4px;\n  border: 1px solid ", ";\n"], ["\n  ", ";\n  padding: 6px 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 73px;\n  border-radius: 4px;\n  border: 1px solid ", ";\n"])), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'label')), design_system_foundations_1.theme.color.transparent); };
exports.baseBadgeStyles = baseBadgeStyles;
var badgeStyles = function (color, variant, selectedTheme) { return (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", "\n  ", "\n"], ["\n  ", ";\n  ", "\n  ", "\n"])), (0, exports.baseBadgeStyles)(selectedTheme), variant === types_1.BadgeVariants.Normal && (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), (0, design_system_foundations_1.getPrefixedThemeColor)(color), (0, design_system_foundations_1.AccessibleTextColor)(color, 'body', selectedTheme)), variant === types_1.BadgeVariants.Soft && (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n     background-color: ", ";\n     color: ", ";\n     border: 1px solid ", ";\n   "], ["\n     background-color: ", ";\n     color: ", ";\n     border: 1px solid ", ";\n   "])), (0, design_system_foundations_1.getPrefixedThemeColor)(color), (0, badgeUtils_1.getSoftColors)(color).text, design_system_foundations_1.theme.color.transparent)); };
exports.badgeStyles = badgeStyles;
function isSoftBadgeColor(color) {
    return !!color && !!types_1.softBadgeColors.find(function (badgeColor) { return badgeColor === color; });
}
exports.isSoftBadgeColor = isSoftBadgeColor;
exports.Badge = (0, react_1.forwardRef)(function (_a, ref) {
    var color = _a.color, children = _a.children, testId = _a.testId, className = _a.className, _b = _a.variant, variant = _b === void 0 ? types_1.BadgeVariants.Normal : _b, style = _a.style, rest = __rest(_a, ["color", "children", "testId", "className", "variant", "style"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    if (variant === types_1.BadgeVariants.Soft && !isSoftBadgeColor(color)) {
        var message = "Invalid ".concat(variant, " variant badge color, valid colors are [").concat(types_1.softBadgeColors.join(', '), "] and you passed in [").concat(color, "].");
        console.error(message);
        return react_1.default.createElement(design_system_typography_1.Text, { color: "red70" }, message);
    }
    var classes = (0, css_1.cx)((0, exports.badgeStyles)(color, variant, selectedTheme), className, 'ds-badge');
    return (react_1.default.createElement("span", __assign({ className: classes, style: style, ref: ref, "data-testid": testId }, rest), children));
});
exports.Badge.displayName = 'Badge';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
